import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderMain from "./HeaderMain";
import Footer from "./Footer";
import ContactUsModal from "./ContactUsModal";
import LandingPage from "./LandingPage";
import LandingPageDemo from "./LandingPage-Demo";
// import LandingPageDemo from "./LandingPage-Demo";
import LandingPageAnimation from "./LandingPage-Animation";
import LandingPageEducation from "./LandingPage-Education";
import LandingPageQuiz from "./LandingPage-Quiz";
import LandingPageUsage from "./LandingPage-Usage";
import LandingPage_Features from "./LandingPage-Features";
import LandingPage_HowItWorks from "./LandingPage-HowItWorks";
import LandingPage_Blogs from "./LandingPage-Blogs";
import LandingPage_FAQ from "./LandingPage-FAQ";
import LandingPageTryItOut from "./LandingPage-TryItOut";
import StayInformed from "./StayInformed";

function Main({ version }) {
  const navigate = useNavigate();
  const handleGoToApp = () => navigate("/app");
  const [showStayInformed, setShowStayInformed] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  // Detect mobile screen size
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Get version from prop, or from URL query parameter, default to "animated"
  const searchParams = new URLSearchParams(location.search);
  const landingVersion = version || searchParams.get("version") || "animated";

  const handleStayInformedClick = () => {
    setShowStayInformed(true);
  };

  const handleBackToHome = () => {
    setShowStayInformed(false);
  };

  const handlePricingClick = () => {
    // This will be handled by HeaderMain's modal
    const pricingLink = document.querySelector('a[href="#pricing"]');
    if (pricingLink) {
      pricingLink.click();
    }
  };

  const handleContactClick = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  // Render the appropriate landing page based on version
  const renderLandingPage = () => {
    // Always use static version on mobile
    if (isMobile) {
      return <LandingPage onManageAccountClick={handleGoToApp} />;
    }

    switch (landingVersion) {
      case "demo":
        return <LandingPageDemo onManageAccountClick={handleGoToApp} />;
      // case "ABTesting":
      //   // You can add A/B testing logic here
      //   return Math.random() < 0.5 ? (
      //     <LandingPage onManageAccountClick={handleGoToApp} />
      //   ) : (
      //     <LandingPageAnimation onManageAccountClick={handleGoToApp} />
      //   );
      case "standard":
        return <LandingPage onManageAccountClick={handleGoToApp} />;
      case "animated":
      default:
        return <LandingPageAnimation onManageAccountClick={handleGoToApp} />;
    }
  };

  return (
    <div className="main-container">
      <HeaderMain
        onStayInformedClick={handleStayInformedClick}
        onBackToHome={handleBackToHome}
        isInStayInformedView={showStayInformed}
      />
      {showStayInformed ? (
        <StayInformed onBack={handleBackToHome} />
      ) : (
        <>
          {renderLandingPage()}
          <LandingPageTryItOut onManageAccountClick={handleGoToApp} />
          <LandingPageQuiz onManageAccountClick={handleGoToApp} />
          <LandingPageUsage />
          <LandingPageEducation />
          <LandingPage_Features onManageAccountClick={handleGoToApp} />
          {/* <LandingPage_HowItWorks onManageAccountClick={handleGoToApp} /> */}
          <LandingPage_Blogs />
          <LandingPage_FAQ />
        </>
      )}
      <Footer
        onPricingClick={handlePricingClick}
        onContactClick={handleContactClick}
      />
      {isContactModalOpen && (
        <ContactUsModal onClose={handleCloseContactModal} />
      )}
    </div>
  );
}

export default Main;
